import { render, staticRenderFns } from "./ResultStep.vue?vue&type=template&id=c321b4e6&scoped=true"
import script from "./ResultStep.vue?vue&type=script&lang=js"
export * from "./ResultStep.vue?vue&type=script&lang=js"
import style0 from "./ResultStep.vue?vue&type=style&index=0&id=c321b4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321b4e6",
  null
  
)

export default component.exports